import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { JiraIcon } from '@atlaskit/logo/jira-icon';
import { JiraServiceManagementIcon } from '@atlaskit/logo/jira-service-management-icon';
import { LoomIcon } from '@atlaskit/logo/loom/icon';

import { get3PLogo, RovoLogoFromGlyph, RovoLogoFromLogo, type RovoLogo } from './icons';

import { AdobeSignIcon } from './icons/adobe-sign';

import { AdobeXDIcon } from './icons/adobe-xd';

import { AhaIcon } from './icons/aha';

import { AirtableIcon } from './icons/airtable';

import { AmplitudeIcon } from './icons/amplitude';

import { AsanaIcon } from './icons/asana';

import { AWSS3Icon } from './icons/aws-s3';

import { AzureDevopsIcon } from './icons/azure-devops';

import { BoxIcon } from './icons/box';

import { CanvaIcon } from './icons/canva';

import { ClickUpIcon } from './icons/clickup';

import { DatabricksIcon } from './icons/databricks';

import { DocusignIcon } from './icons/docusign';

import { DovetailIcon } from './icons/dovetail';

import { DropboxIcon } from './icons/dropbox';

import { FigmaIcon } from './icons/figma';

import { FreshserviceIcon } from './icons/freshservice';

import { GitbookIcon } from './icons/gitbook';

import { GithubIcon } from './icons/github';

import { GitlabIcon } from './icons/gitlab';

import { GmailIcon } from './icons/gmail';

import { GoogleDriveIcon } from './icons/google';

import { GoogleCalendarIcon } from './icons/google-calendar';

import { HubSpotFilterIcon } from './icons/hubspot';

import { LaunchDarklyIcon } from './icons/launchdarkly';

import { LucidIcon } from './icons/lucid';

import { MiroIcon } from './icons/miro';

import { MondayIcon } from './icons/monday';

import { MuralIcon } from './icons/mural';

import { NotionIcon } from './icons/notion';

import { OneDriveIcon } from './icons/onedrive';

import { OutlookCalendarIcon } from './icons/outlook-calendar';

import { OutlookMailIcon } from './icons/outlook-mail';

import { PagerDutyIcon } from './icons/pagerduty';

import { PipedriveIcon } from './icons/pipedrive';

import { PowerBIIcon } from './icons/powerBI';

import { SalesforceIcon } from './icons/salesforce';

import { SentryIcon } from './icons/sentry';

import { ServiceNowIcon } from './icons/servicenow';

import { SharePointIcon } from './icons/sharepoint';

import { SlackIcon } from './icons/slack';

import { SmartsheetIcon } from './icons/smartsheet';

import { StripeIcon } from './icons/stripe';

import { TeamsIcon } from './icons/teams';

import { TodoistIcon } from './icons/todoist';

import { WebexIcon } from './icons/webex';

import { ZendeskIcon } from './icons/zendesk';

import { ZeplinIcon } from './icons/zeplin';

export const ThirdPartyIcons: Map<string, RovoLogo> = new Map([
	['adobe-sign', get3PLogo(AdobeSignIcon, 'Adobe Sign', 'medium')],
	['adobexd', get3PLogo(AdobeXDIcon, 'AdobeXD', 'medium')],
	['aha', get3PLogo(AhaIcon, 'Aha', 'medium')],
	['airtable', get3PLogo(AirtableIcon, 'Airtable', 'medium')],
	['amplitude', get3PLogo(AmplitudeIcon, 'Amplitude', 'medium')],
	['asana', get3PLogo(AsanaIcon, 'Asana', 'medium')],
	['aws-s3', RovoLogoFromLogo(AWSS3Icon, 'Amazon Web Services S3')],
	['azure-devops', get3PLogo(AzureDevopsIcon, 'AzureDevOps', 'medium')],
	['box', get3PLogo(BoxIcon, 'Box', 'medium')],
	['canva', get3PLogo(CanvaIcon, 'Canva', 'medium')],
	['clickup', get3PLogo(ClickUpIcon, 'ClickUp', 'medium')],
	['confluence-dc', RovoLogoFromLogo(ConfluenceIcon, 'Confluence Data Center')],
	['databricks', get3PLogo(DatabricksIcon, 'Databricks', 'medium')],
	['docusign', get3PLogo(DocusignIcon, 'Docusign', 'medium')],
	['dovetail', get3PLogo(DovetailIcon, 'Dovetail', 'medium')],
	['drive', get3PLogo(GoogleDriveIcon, 'Google Drive', 'medium')],
	['dropbox', get3PLogo(DropboxIcon, 'Dropbox', 'medium')],
	['figma', get3PLogo(FigmaIcon, 'Figma', 'medium')],
	['freshservice', get3PLogo(FreshserviceIcon, 'Freshservice', 'medium')],
	['gitbook', RovoLogoFromLogo(GitbookIcon, 'GitBook')],
	['github', get3PLogo(GithubIcon, 'Github', 'medium')],
	['gitlab', get3PLogo(GitlabIcon, 'Gitlab', 'medium')],
	['gmail', get3PLogo(GmailIcon, 'Gmail', 'medium')],
	['google-calendar', get3PLogo(GoogleCalendarIcon, 'Google Calendar', 'medium')],
	['hubspot', RovoLogoFromGlyph(HubSpotFilterIcon, 'HubSpot')],
	['jira-dc', RovoLogoFromLogo(JiraIcon, 'Jira Data Center')],
	['jsm-dc', RovoLogoFromLogo(JiraServiceManagementIcon, 'JSM Data Center')],
	['launchdarkly', get3PLogo(LaunchDarklyIcon, 'LaunchDarkly', 'medium')],
	['loom', RovoLogoFromLogo(LoomIcon, 'small')],
	['lucid', get3PLogo(LucidIcon, 'Lucid', 'medium')],
	['miro', get3PLogo(MiroIcon, 'Miro', 'medium')],
	['monday', get3PLogo(MondayIcon, 'Monday', 'medium')],
	['mural', get3PLogo(MuralIcon, 'Mural', 'medium')],
	['notion', get3PLogo(NotionIcon, 'Notion', 'medium')],
	['onedrive', get3PLogo(OneDriveIcon, 'OneDrive', 'medium')],
	['outlook-calendar', get3PLogo(OutlookCalendarIcon, 'Outlook Calendar', 'medium')],
	['outlook-mail', get3PLogo(OutlookMailIcon, 'Outlook Mail', 'medium')],
	['pagerduty', get3PLogo(PagerDutyIcon, 'PagerDuty', 'medium')],
	['pipedrive', get3PLogo(PipedriveIcon, 'Pipedrive', 'medium')],
	['power-bi', get3PLogo(PowerBIIcon, 'PowerBI', 'medium')],
	['salesforce', get3PLogo(SalesforceIcon, 'Salesforce', 'medium')],
	['sentry', get3PLogo(SentryIcon, 'Sentry', 'medium')],
	['servicenow', get3PLogo(ServiceNowIcon, 'ServiceNow', 'medium')],
	['sharepoint', get3PLogo(SharePointIcon, 'Sharepoint', 'medium')],
	['slack', get3PLogo(SlackIcon, 'Slack', 'medium')],
	['smartsheet', get3PLogo(SmartsheetIcon, 'Smartsheet', 'medium')],
	['stripe', get3PLogo(StripeIcon, 'Stripe', 'medium')],
	['teams', get3PLogo(TeamsIcon, 'Teams', 'medium')],
	['todoist', get3PLogo(TodoistIcon, 'Todoist', 'medium')],
	['webex', get3PLogo(WebexIcon, 'Webex', 'medium')],
	['zendesk', get3PLogo(ZendeskIcon, 'Zendesk', 'medium')],
	['zeplin', get3PLogo(ZeplinIcon, 'Zeplin', 'medium')],
]);
